<template>
  <div class="container-keywords">
    <div>
      <div class="container-keywords-title">
        <img src="/hashtag.svg" alt="chat" />
        <span class="keywords-title"> Palavras-chave em alta </span>
      </div>
      <span v-if="this.days > 0" class="keywords-subtitle"> Nos últimos {{ this.days }} dias </span>
      <CustomSkeleton
        v-if="isSearching"
        :listWidth="{ firstLine: '400px', secondLine: '300px' }"
        :listHeight="{ thirdLine: '100px' }"
        type="list"
      />
      <div v-if="!isSearching" class="keywords-block-pills">
        <span v-if="capitalizedKeywords.length === 0 && !isSearching" class="no-data-text">
          Não há palavras-chaves nessa data.
        </span>
        <div
          v-for="(keyword, index) in capitalizedKeywords"
          :key="index + 'negative_keywords'"
          class="keywords-pill"
          :title="keyword.mentions + ' Impressões'"
        >
          {{ keyword.keyword }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSkeleton from '@/Shared/CustomSkeleton'
export default {
  props: {
    isSearching: Boolean,
    keyWords: Array,
    days: Number,
  },
  components: { CustomSkeleton },
  computed: {
    capitalizedKeywords() {
      return this.keyWords
        .filter((item) => this.isValidKeyword(item.keyword))
        .map((item) => {
          return {
            keyword: item.keyword.charAt(0).toUpperCase() + item.keyword.slice(1),
            mentions: item.mentions,
          }
        })
    },
  },
  methods: {
    isValidKeyword(keyword) {
      const trimmedKeyword = keyword.trim()
      const invalidKeywords = ['️']
      return trimmedKeyword.length > 0 && !invalidKeywords.includes(trimmedKeyword)
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
